import Col from './Col';


Col.install = function(Vue) {
  Vue.component(Col.name, Col);
};

export default Col;
